"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// Import polyfills first, before any other imports
require("./polyfills");
var react_1 = require("react");
var client_1 = require("react-dom/client");
var react_router_dom_1 = require("react-router-dom");
require("./index.css");
var App_tsx_1 = require("./App.tsx");
var WalletContextProvider_tsx_1 = require("./context/WalletContextProvider.tsx");
var root = (0, client_1.createRoot)(document.getElementById('root'));
root.render((0, jsx_runtime_1.jsx)(react_1.StrictMode, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { basename: import.meta.env.BASE_URL, children: (0, jsx_runtime_1.jsx)(WalletContextProvider_tsx_1.default, { children: (0, jsx_runtime_1.jsx)(App_tsx_1.default, {}) }) }) }));
